import utils from '../../../utils';
import fetch from '../../fetch';

import { Modal, message } from 'antd';


const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 10
        },
        {
            key:'orgName', 
            label: '部门'
        },
        {
            key:'employeeCode', 
            label: '职工号'
        },
        {
            key: 'realName',
            label:  '姓名'
        },
        {
            key: 'employeePropertyName',
            label: '教师性质'
        },
        {
            key: 'isEval',
            label: '是否参评',
            render: (val) => {
                if(val === 0) {
                    return "未参评";
                } else if (val === 1) {
                    return "参评";
                } else {
                    return "未知";
                }
            }
        }
    ]
)


const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('surveyteacherpublish/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

// const batchRemove = (callback, loading) => {
//     if(DataGrid.selections.length === 0) {
//         Modal.error({
//             title: '请先选择一项或多项！',
//             content: '只有勾选一项或多项后才能删除！',
//         });
//     } else {
//         Modal.confirm({
//             title: '确定删除所选数据？',
//             content: '删除后将无法恢复！',
//             onOk() {
//                 loading();
//                 remove(DataGrid.selections).then(response => {
//                     if(response.code === 200) {
//                         message.success(response.message);
//                         callback();
//                     } else {
//                         Modal.error({
//                             title: '消息',
//                             content: response.message,
//                             okText: '确认'
//                         })
//                     }
//                 });
//             },
//             onCancel() {},
//             okText:"确认",
//             cancelText:"取消"
//         });
//     }
// }

const batchRemove = (callback, loading) => {
    if(DataGrid.selections.length === 0) {
        Modal.confirm({
            title: '确认删除全部？',
            content: '没有选择数据，将删除全部数据',
            onOk: () => {
                Modal.confirm({
                    title: '再次确认是否删除全部数据？',
                    content: '点击确认删除全部数据',
                    onOk: () => {
                        loading();
                        remove([-1]).then(response => {
                            if(response.code === 200) {
                                message.success(response.message);
                                callback();
                            } else {
                                Modal.error({
                                    title: '消息',
                                    content: response.message,
                                    okText: '确认'
                                })
                            }
                        });
                    },
                    okText:"确认",
                    cancelText:"取消"
                })
            },
            okText:"确认",
            cancelText:"取消"
        });
    } else {
        Modal.confirm({
            title: '确定删除所选数据？',
            content: '删除后将无法恢复！',
            onOk() {
                loading();
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    } else {
                        Modal.error({
                            title: '消息',
                            content: response.message,
                            okText: '确认'
                        })
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const remove = (ids) => {
    return fetch.post('surveyteacherpublish/delete', ids)
    .then(response => {
        onSelect([]);
        return response;
    }).catch(error => {
        return error;
    });
}

const queryPropertiesList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/employee/property', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPublishObject = () => {
    return fetch.get('platform/code/publish/object')
    .then(response => {
        return response.payload.data
    })
}

const create = (keywords) => {
    let orgIds = [];
    if(keywords.orgId) {
        orgIds.push(keywords.orgId);
    }
    keywords['orgIds'] = orgIds;
    keywords['employeeProperty'] = keywords.teacherProperty
    return fetch.post('/surveyteacherpublish/create', keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).catch(error => {
        return error;
    })
}

const publish = (keywords) => {
    return fetch.post('surveyteacherpublish/publish', keywords)
    .then((response) => {
        if(response.code == 200) {
            return response.payload.data
        }
    }).catch(error => {
        Modal.error({
            title: '发布失败',
            content: '发布失败',
            onOk: () => {}
        })
    })
}

export default {
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    querySearch,
    getSelection,
    batchRemove,
    queryPropertiesList,
    create,
    publish,
    queryPublishObject
}